import { type GISStateLayer } from './gisServicesTypes';

/**
 * Sublayer uniqueIds that should be hidden for the given layer and role, per
 * the layer's `roles_config` exclude list. Role matching is case-insensitive.
 *
 * Lives apart from the slice because both the reducers and the ArcGIS-bound
 * thunks need it, and the slice must not depend on the thunks.
 */
export function computeFilteredSublayerIds(
  layer: GISStateLayer,
  roleName?: string,
): string[] {
  const rolesConfig = layer.service.attributes?.roles_config;

  if (!rolesConfig?.roles || !roleName) {
    return [];
  }

  const filteredIds: string[] = [];

  for (const role of rolesConfig.roles) {
    if (role.name.toLowerCase() !== roleName.toLowerCase()) {
      continue;
    }

    for (const sublayer of layer.sublayers) {
      const isExcluded = role.exclude.some(
        excludeTitle =>
          excludeTitle.toLowerCase() === sublayer.title.toLowerCase(),
      );
      if (isExcluded) {
        filteredIds.push(sublayer.uniqueId);
      }
    }
  }

  return filteredIds;
}
